module.exports = __webpack_public_path__ + "img/img7.d0b132bf.svg";